interface BasicImageInfo {
    url: string;
    isMain: boolean;
    isActive: boolean;
    imageInfo: string;
}

export class ProductImageFormModel {
    static MAX_SIZE_MB = 5;
    
    images: BasicImageInfo[] = [];
    event?: Event;
    url?: string = '';

    updateImages(event: Event):void {
        this.event = event;
    }

    clear():void {       
        this.images = [];
        this.url = '';
    }

    getFiles():FileList | never[] {
        return (this.event?.target as HTMLInputElement)?.files || [];
    }

    hasUrl():boolean {
        return !!this.url;
    }

    hasImages():boolean {
        const files = (this.event?.target as HTMLInputElement)?.files

        if (!this.url && !files?.length) {
            return false;
        }

        if (files?.length) {
            return true;
        }

        if (this.url && /^http/.test(this.url)) {
            return true
        }

        return false
    }
}
